import { Component, OnInit, Input } from '@angular/core';
import { CMSContentService } from '../../../essentials/cms/content/cms-content.service';
import { Router } from '@angular/router';

@Component({
  selector: 'fcp-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {
  @Input() data: any;
  @Input() social: any;

  constructor(
    private cmsContent: CMSContentService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  openModal(modal) {
    this.cmsContent.openModal(modal);
  }

  goTo(term) {
    this.router.navigateByUrl(term);
  }
}
